import { render, staticRenderFns } from "./AdsHorizontal.vue?vue&type=template&id=e6d4c69c&scoped=true&"
import script from "./AdsHorizontal.vue?vue&type=script&lang=js&"
export * from "./AdsHorizontal.vue?vue&type=script&lang=js&"
import style0 from "./AdsHorizontal.vue?vue&type=style&index=0&id=e6d4c69c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6d4c69c",
  null
  
)

export default component.exports